import AddOnIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/AddOnIconPath";
import DataChartIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/DataChartIconPath";
import ClipboardCheckmarkIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ClipboardCheckmarkIconPath";
import RoomLayoutIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/RoomLayoutIconPath";
import ShoppingBagIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ShoppingBagIconPath";
import SpeechBubbleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/SpeechBubbleIconPath";
import BoxCancelIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/BoxCancelIconPath";
import ChairIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChairIconPath";
import PencilIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PencilIconPath";
import LinkOutIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import MultiAddOnIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MultiAddOnIconPath";
import CheckmarkCircleIconPath from "../../../../shared/wrappers/FixaSSRIcon/paths/CheckmarkCircleIconPath";

import { TaskTypesRoutes } from "../../../../home/constants/taskTypesRoutes";
import PeopleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PeopleIconPath";

const NavigationLabelsKeys = {
  ADDON: "addonString",
  INSIGHTS: "capitalCaseAddonInsightsString",
  TEST_BUY: "capitalCaseTestBuyString",
  ROOM_SETTINGS: "roomSettingsString",
  MEDIA_MAINTENANCE_ROOM_SETTINGS: "capitalCaseMediaMaintenanceString",
  SHOPPING_TOOLS: "shoppingToolsString",
  CUSTOMER_MFAQ: "customerQuestionsString",
  PRODUCT_QUALITY_REPORT: "capitalCaseProductQualityReportString",
  PRODUCT_ISSUE: "productString",
  CUSTOM_TASK: "capitalCaseCustomString",
  DASHBOARD: "dashboardString",
  MULTI_ORDER_ADDON: "capitalCaseMultiOrderAddOnsString",
  TASKS: "TasksString",
  TEAMS_MANAGER: "capitalCaseTeamManagementString",
};

export enum MenuIdTypes {
  TASKS = "tasks",
  ADDON = "addon",
  DASHBOARD = "dashboard",
  INSIGHTS = "insights",
  TEST_BUY = "test-buy",
  ROOM_SETTINGS = "room-setting",
  SHOPPING_TOOLS = "shopping-tools",
  CUSTOMER_MFAQ = "customer-mfaq",
  PRODUCT_QUALITY_REPORT = "product-quality-report",
  PRODUCT_ISSUE = "product-issue",
  CUSTOM_TASK = "customer-task",
  MULTI_ORDER_ADDONS = "multi-order-addons",
  TEAMS_MANAGER = "teams-manager",
}

export type NavigationItem = {
  id: string;
  orderIndex: number;
  icon: (prefix?: string) => React.SVGProps<SVGElement>[];
  labelTranslationKey: string;
  href?: string;
  taskType?: string;
  link?: string;
  testId: string;
};

export const TaskItem = {
  id: MenuIdTypes.TASKS,
  icon: CheckmarkCircleIconPath,
  orderIndex: 11,
  labelTranslationKey: NavigationLabelsKeys.TASKS,
  href: "/tasks",
  testId: "taskNavigationButton",
};

export const MultiOrderAddOnItem = {
  id: MenuIdTypes.MULTI_ORDER_ADDONS,
  orderIndex: 1,
  icon: MultiAddOnIconPath,
  labelTranslationKey: NavigationLabelsKeys.MULTI_ORDER_ADDON,
  href: "/multi-order-addons",
  testId: "multiAddonNavigationButton",
};

export const TeamsManagerItem = {
  id: MenuIdTypes.TEAMS_MANAGER,
  icon: PeopleIconPath,
  labelTranslationKey: NavigationLabelsKeys.TEAMS_MANAGER,
  orderIndex: 0,
  href: "/teams",
  testId: "teamsManagerNavigationButton",
};

export const NavigationItemsConfig: NavigationItem[] = [
  {
    id: MenuIdTypes.DASHBOARD,
    orderIndex: 11,
    icon: LinkOutIconPath,
    labelTranslationKey: NavigationLabelsKeys.DASHBOARD,
    link: "https://fixadashboard.ingka.com",
    testId: "dashboardNavigationButton",
  },
  {
    id: MenuIdTypes.ADDON,
    orderIndex: 10,
    icon: AddOnIconPath,
    labelTranslationKey: NavigationLabelsKeys.ADDON,
    taskType: TaskTypesRoutes.ADDON,
    testId: "addonNavigationButton",
  },
  {
    id: MenuIdTypes.INSIGHTS,
    orderIndex: 9,
    icon: DataChartIconPath,
    labelTranslationKey: NavigationLabelsKeys.INSIGHTS,
    href: "/insights",
    testId: "insideNavigationButton",
  },
  {
    id: MenuIdTypes.TEST_BUY,
    orderIndex: 8,
    icon: ClipboardCheckmarkIconPath,
    labelTranslationKey: NavigationLabelsKeys.TEST_BUY,
    href: "/testbuy",
    testId: "testBuyNavigationButton",
  },
  {
    id: MenuIdTypes.ROOM_SETTINGS,
    orderIndex: 7,
    icon: RoomLayoutIconPath,
    labelTranslationKey: NavigationLabelsKeys.MEDIA_MAINTENANCE_ROOM_SETTINGS,
    href: "/mediamaintenance",
    testId: "roomSettingsNavigationButton",
  },
  {
    id: MenuIdTypes.SHOPPING_TOOLS,
    orderIndex: 6,
    icon: ShoppingBagIconPath,
    labelTranslationKey: NavigationLabelsKeys.SHOPPING_TOOLS,
    href: "/shoppingtools",
    testId: "shoppingToolsNavigationButton",
  },
  {
    id: MenuIdTypes.CUSTOMER_MFAQ,
    orderIndex: 5,
    icon: SpeechBubbleIconPath,
    labelTranslationKey: NavigationLabelsKeys.CUSTOMER_MFAQ,
    href: "/customerquestions",
    testId: "customerQuestionsNavigationButton",
  },
  {
    id: MenuIdTypes.PRODUCT_QUALITY_REPORT,
    orderIndex: 4,
    icon: BoxCancelIconPath,
    labelTranslationKey: NavigationLabelsKeys.PRODUCT_QUALITY_REPORT,
    taskType: TaskTypesRoutes.PRODUCT_QUALITY,
    testId: "productQualityReportNavigationButton",
  },
  {
    id: MenuIdTypes.PRODUCT_ISSUE,
    orderIndex: 3,
    icon: ChairIconPath,
    labelTranslationKey: NavigationLabelsKeys.PRODUCT_ISSUE,
    taskType: TaskTypesRoutes.PRODUCT_ISSUE,
    testId: "productIssueNavigationButton",
  },
  {
    id: MenuIdTypes.CUSTOM_TASK,
    orderIndex: 2,
    icon: PencilIconPath,
    labelTranslationKey: NavigationLabelsKeys.CUSTOM_TASK,
    taskType: TaskTypesRoutes.CUSTOM,
    testId: "customNavigationButton",
  },
];
